import {PAGE_LANDING} from "../constants/PageConstant";
import {OPEN_PAGE} from "../actions/PageActions";

const initialState = {
    page: PAGE_LANDING,
};

export default function ModalReducer(state = initialState, action) {
    switch (action.type) {
        case OPEN_PAGE:
            return {
                ...state,
                page: action.payload
            };
    }

    return state;
}